<div class="session-expired">
  <div class="icon-wrap">
    <mat-icon>lock</mat-icon>
  </div>

  <div class="title">Are you still there?</div>

  <div class="desc">
    Your session has been paused due to inactivity. Click continue to resume where you left off.
  </div>

  <div class="error-text" *ngIf="networkError">
    Couldn't reach the server. Please check your connection and try again.
  </div>

  <button class="continue-btn" (click)="continue()" [disabled]="loading">
    {{ loading ? 'Resuming…' : (networkError ? 'Try Again' : 'Continue') }}
  </button>
</div>
